import { Button, Form, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { UploadFileActionEnum } from '../../../enums/UploadFileActionEnum';

interface Props {
  onSubmit: (action: UploadFileActionEnum) => void;
  onCancel: () => void;
}

export const FileUploadOptionsForm = ({ onSubmit, onCancel }: Props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  /**
   * Handles the submission of form data, processes and transforms it into a `User` object,
   * and passes the constructed user object to the given submission handler.
   *
   * @param {any} values - The form values submitted by the user. Includes fields such as
   * firstName, lastName, email, role, expirationDate, and privateUser.
   */
  const handleFinish = (values: any) => {
    onSubmit(values.action);
  };

  return (
    <Form
      layout="vertical"
      form={form}
      size="large"
      initialValues={{
        action: UploadFileActionEnum.Replace,
      }}
      className="pt-6! [&_.ant-form-item]:mb-2! [&_.ant-form-item-explain-error]:hidden! [&_.ant-form-item-label]:hidden!"
      onFinish={handleFinish}
    >
      <Form.Item name="action" rules={[{ required: true }]}>
        <Radio.Group
          className="flex! flex-col! gap-4!"
          options={[
            {
              value: UploadFileActionEnum.Replace,
              label: t('modal.fileUploadOptionsForm.replaceExistingFile'),
            },
            {
              value: UploadFileActionEnum.NewOnly,
              label: t('modal.fileUploadOptionsForm.newOnly'),
            },
            {
              value: UploadFileActionEnum.KeepBoth,
              label: t('modal.fileUploadOptionsForm.keepBothFiles'),
            },
          ]}
        />
      </Form.Item>
      <div className="mt-4 flex flex-row items-center justify-end gap-2">
        <Button size="middle" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
        <Button size="middle" type="primary" htmlType="submit">
          {t('common.upload')}
        </Button>
      </div>
    </Form>
  );
};

export default FileUploadOptionsForm;
